import React from 'react';

/** Swatch colours match `.schedule-gantt-viewport .wx-bar` rules in `App.css`. */
export const SCHEDULE_LEGEND_ITEMS: ReadonlyArray<{ swatch: string; label: string }> = [
  { swatch: 'schedule-legend-swatch-planned', label: 'Planned' },
  { swatch: 'schedule-legend-swatch-active', label: 'Active' },
  { swatch: 'schedule-legend-swatch-overdue', label: 'Overdue' },
  { swatch: 'schedule-legend-swatch-closed', label: 'Closed / Finalized' },
  { swatch: 'schedule-legend-swatch-summary', label: 'Project or resource summary' },
];

/**
 * The chart key (W-M13, W-iP3): one spaced row at the top of the chart that wraps on a narrow
 * screen. Each entry is its own list item with a gap, so labels can never run together
 * ("Red – OverdueGreen – Active"); the swatch carries the colour, the text names the meaning.
 */
const ScheduleChartLegend: React.FC = () => {
  return (
    <ul
      className="schedule-chart-legend tw-m-0 tw-flex tw-min-w-0 tw-list-none tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-1 tw-p-0 tw-text-sm tw-text-content-secondary"
      aria-label="Chart key"
    >
      {SCHEDULE_LEGEND_ITEMS.map((item) => (
        <li key={item.label} className="schedule-legend-item tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap">
          <span className={`schedule-legend-swatch ${item.swatch}`} aria-hidden />
          <span>{item.label}</span>
        </li>
      ))}
      <li className="schedule-legend-item tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap">
        <span className="schedule-legend-today-mark" aria-hidden />
        <span>Today</span>
      </li>
      <li
        className="schedule-legend-item tw-inline-flex tw-items-center tw-gap-1.5 tw-whitespace-nowrap"
        title="More than one resource is assigned to the same task - adjust dates or resources"
      >
        {/* V2-062: plain words, not a bracketed all-caps tag. */}
        <span>
          <strong className="tw-text-content">Conflict</strong> – overlapping assignment
        </span>
      </li>
    </ul>
  );
};

export default ScheduleChartLegend;
